/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from "react";
import { useLocation } from "react-router-dom";

//vlinder libs
import { useViewport } from "@vlinder-web/viewport-provider-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { TypeWriterLoaderVW } from "@vlinder-web/typewriter-loader-widget-react";

import { ContainerSM } from "./container.sm";
import { getCredentialVerified } from "../components/getCredentialVerified";
import { VApplication } from "../../../application";
import {
  FullProvenancePageService,
  ProvenanceDetailPageService,
} from "../../../services";

//verify credntial machine
import { useSMVerifyCredential } from "../machines";

const log: any = LoggerModule?.getInstance();

const getSev = () => {
  const app = VApplication?.getInstance();
  return app.getSync(
    "services.FullProvenancePageService"
  ) as FullProvenancePageService;
};

const getProvev = () => {
  const app = VApplication?.getInstance();
  return app.getSync(
    "services.ProvenanceDetailPageService"
  ) as ProvenanceDetailPageService;
};

export const ProvenanceDetail = (props: any) => {
  const { bp } = useViewport();
  const location = useLocation();
  //const staticPageContentConfig = getSev()?.getStaticPageContent();
  const staticPageContentConfig = getProvev()?.getStaticPageContent();
  const ocrFullProvenanceState = getSev()?.ocrProvenanceData;

  const { verifyCredentialSend, verifyCredentialState } = useSMVerifyCredential(
    {}
  );

  log.blue(
    ` details in provenance details :`,
    location?.state?.type,
    location?.state?.data
  );

  const data = location?.state?.data;

  log.blue(
    `verifyCredentialState : :`,
    verifyCredentialState?.event?.data?.value,
    ocrFullProvenanceState?.provenanceData
  );

  if (
    verifyCredentialState.matches("RENDER_VERIFIED_CREDENTIAL_PAGE") &&
    verifyCredentialState?.event?.data?.value &&
    ocrFullProvenanceState?.provenanceData &&
    data
  ) {
    const _provenanceData = getCredentialVerified(
      ocrFullProvenanceState?.provenanceData,
      data?.credTxId,
      verifyCredentialState?.event?.data?.value
    );
    if (_provenanceData) {
      const content = {
        ...ocrFullProvenanceState,
        provenanceData: _provenanceData,
      };
      getSev()?.setOcrFullProvenanceData(content);
    }
  } else if (verifyCredentialState.matches("GET_VERIFIED_CREDENTIAL")) {
    return <TypeWriterLoaderVW />;
  }

  const _onVerifyCredential = () => {
    log.blue(`onVerifyCredential :`, data);
    verifyCredentialSend("START", {
      credTxId: data?.credTxId,
      gtin: data?.gtinKey,
    });
  };

  if (bp === "xs" || bp === "sm") {
    return (
      <ContainerSM
        {...props}
        data={verifyCredentialState?.event?.data?.value ?? data} //staticPageContentConfig?.provenanceDetail
        onVerifyCredential={_onVerifyCredential}
        staticData={staticPageContentConfig?.provenanceDetail}
        type={location?.state?.type}
      />
    );
  } else {
    return <div />;
  }
};
